import { createSlice } from '@reduxjs/toolkit'

import type { RootState } from '../store'
import type { PayloadAction } from '@reduxjs/toolkit'

type PasswordLeakState = {
  isLeaked: boolean
  notNow: boolean
}

type State = {
  isOrganizerConfirmed: boolean
  passwordLeakState: PasswordLeakState
  previousState: Record<string, unknown> | null
}

const initialState: State = {
  isOrganizerConfirmed: false,
  passwordLeakState: { isLeaked: false, notNow: false },
  previousState: null
}

export const confirmOrganizerPasswordSlice = createSlice({
  name: 'confirmOrganizerPassword',
  initialState,
  reducers: {
    setOrganizerConfirmed(state, action: PayloadAction<boolean>) {
      state.isOrganizerConfirmed = action.payload
    },
    setOrganizerPasswordLeakState(state, action: PayloadAction<Partial<PasswordLeakState>>) {
      state.passwordLeakState = { ...state.passwordLeakState, ...action.payload }
    },
    setOrganizerPreviousState(state, action: PayloadAction<Record<string, unknown>>) {
      state.previousState = action.payload
    },
    clearOrganizer() {
      return initialState
    }
  }
})

export const { setOrganizerConfirmed, setOrganizerPasswordLeakState, setOrganizerPreviousState, clearOrganizer } =
  confirmOrganizerPasswordSlice.actions

export const selectIsOrganizerLeaked = (state: RootState) => state.confirmOrganizerPassword.passwordLeakState.isLeaked

export default confirmOrganizerPasswordSlice
